export default __webpack_public_path__ + "static/media/keyboard.d00133d3.mp4";